export default __webpack_public_path__ + "static/media/hht2_ep15_timeline_q04_b.4e3957ee.png";